import { Modal } from './Modal';
import { Button } from './Button';
import { MachhaCharacter } from '../../lib/machhaAsset';
import { usePermissionDeniedStore } from '../../store/permissionDeniedStore';
import styles from './PermissionDeniedModal.module.css';

/**
 * Global modal shown when a manager attempts an action their permissions don't
 * allow. Driven by usePermissionDeniedStore — mounted once at the app root.
 */
export function PermissionDeniedModal() {
  const open = usePermissionDeniedStore((s) => s.open);
  const action = usePermissionDeniedStore((s) => s.action);
  const close = usePermissionDeniedStore((s) => s.close);

  return (
    <Modal isOpen={open} onClose={close} size="sm">
      <div className={styles['wrap']}>
        <div className={styles['mascot']}>
          <MachhaCharacter state="Forbidden" part="body" size={132} />
        </div>
        <h2 className={styles['title']}>You don&apos;t have access</h2>
        <p className={styles['message']}>
          You don&apos;t have permission to {action ?? 'perform this action'}. Ask the
          event creator if you need it.
        </p>
        <div className={styles['actions']}>
          <Button variant="primary" onClick={close}>
            Got it
          </Button>
        </div>
      </div>
    </Modal>
  );
}
